import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Header from '../components/Header';
import Banner from '../components/Banner';
import Users from './sections/Users';
import UserGroup from './sections/UserGroups';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function UserManagement() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
    <Header />
    <Banner small />
    <Box sx={{marginTop: "60px"}}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '91%', marginLeft: "60px" }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Manage Users" {...a11yProps(0)} />
          <Tab label="User Groups" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Users/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <UserGroup/>
      </CustomTabPanel>
    </Box>
    </>
  );
}
